<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <vacation-field
          slot="va_vacationtype"
          :label="customLabel.va_vacationtype || '假期类型'"
          v-model="form.main.va_vacationtype"
          @select="onVtChange"
        />
        <div class="weui-cell" slot="va_alltimes">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.va_alltimes || "请假时长"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              :disabled="va_alltimes_disabled"
              v-model="form.main.va_alltimes"
              minvalue="0"
              maxvalue="999"
            />
          </div>
          <div class="weui-cell__ft">h（小时）</div>
        </div>
        <datetime-field
          slot="va_startime"
          :label="customLabel.va_startime || '开始时间'"
          v-model="form.main.va_startime"
          @selected="onCalc"
        />
        <datetime-field
          slot="va_endtime"
          :label="customLabel.va_endtime || '结束时间'"
          v-model="form.main.va_endtime"
          @selected="onCalc"
        />
        <div class="weui-cell weui-cell_active weui-cell_vertical" slot="va_remark">
            <div class="weui-cell__hd"><label for="va_remark" class="weui-label">{{ customLabel.va_remark || '请假原因' }}</label></div>
            <div class="weui-cell__bd">
              <textarea id="va_remark" class="weui-textarea" placeholder="请填写请假原因" rows="3" maxlength="100" 
                v-model="form.main.va_remark"></textarea>
              <div role="option" aria-live="polite" class="weui-textarea-counter"><span>{{
                form.main.va_remark ? form.main.va_remark.length : 0
              }}</span>/100</div>
            </div>
        </div>
      </custom-layout>
      <div class="weui-cells__group" v-if="form.main.va_agent || !outOfDate">
        <div class="weui-cells__title">假期内收到的审批任务自动转给代理人</div>
        <div class="weui-cells">
          <employee-field :label="customLabel.va_agent || '代理人'"
              v-model="form.main.va_agent"
              @select="onSelectAgent"
            />
        </div>
      </div>
      <div class="weui-cells">
        <file-field v-model="form.main.va_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DatetimeField from "@/components/field/DatetimeField.vue";
import FileField from "@/components/field/FileField.vue";
import VacationField from "@/components/field/VacationField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    DatetimeField,
    FileField,
    VacationField,
    EmployeeField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/vacation",
      codeField: "va_code",
      statusField: "va_statuscode",
      caller: "Vacation",
      xtype: "oa-vacation-formpanel",
      form: {
        main: {
          va_vacationtype: "",
          va_startime: null,
          va_endtime: null,
          va_alltimes: 0,
        },
      }
    };
  },
  computed: {
    va_alltimes_disabled() {
      return this.form.main.va_vacationtype.length > 0 && this.vtId != undefined && this.vtId != null
    },
    outOfDate() {
      let va_endtime = this.form.main.va_endtime
      return !va_endtime || new Date(va_endtime).getTime() < Date.now();
    }
  },
  methods: {
    onVtChange(selection) {
      this.vtId = selection.vb_vrId || null

      this.onCalc()
    },
    onCalc() {
      let me = this
      let {va_startime, va_endtime, va_vacationtype} = me.form.main

      if(!va_startime || !va_endtime || !va_vacationtype) return

      let params = {
        start: va_startime,
        end: va_endtime
      }
      if(me.vtId) params.ruleName = va_vacationtype

      me.$loading({
        url: "/api/oa/vacation/getLeaveHours",
        params
      }).then(function(res) {
        if (res.success) {
          me.form.main.va_alltimes = res.data || 0
        }
      });
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.va_vacationtype) {
        me.$weui.topTips("请填写假期类型", 2000);
      } else if (!main.va_startime) {
        me.$weui.topTips("请填写开始时间", 2000);
      } else if (!main.va_endtime) {
        me.$weui.topTips("请填写结束时间", 2000);
      } else if (!main.va_remark) {
        me.$weui.topTips("请填写原因", 2000);
      } else if (!main.va_alltimes) {
        me.$weui.topTips("请填写请假时长", 2000);
      } else if (main.va_alltimes < 0.5) {
        me.$weui.topTips("请假时长最小0.5小时", 2000);
      } else {
        /**
         * 注意：va_code、va_emname在后端接口加了判断，为空则获取默认值
         */
        me.p_save();
      }
    },
    onSelectAgent(selection) {
      var me = this,
        main = me.form.main;
      main.va_agentid = selection.id;
    }
  }
};
</script>